function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*
 * Exportación de la metadata de una tabla en los formatos de las plantillas
 * de carga masiva FOH (ContLoadBulk):
 *  - Metadata de tablas: formato campo-valor (una fila por metadato)
 *  - Metadata de columnas: una fila por columna
 * Los archivos descargados pueden editarse y re-subirse por Carga Masiva.
 */

// Campos de tabla actualizables por la plantilla campo-valor (mismo set que
// TABLE_METADATA_FIELDS de ContLoadBulk; se exportan con su nombre interno)
var TABLE_EXPORT_FIELDS = ['org', 'domain', 'subdomain', 'official_source', 'description', 'operator', 'public', 'env', 'zone', 'area', 'bus_data_steward', 'data_owner', 'tech_data_custodiam', 'table_load_logic', 'tables_relationship', 'upload_platform', 'upload_process', 'final_table'];

// Campos de columna de la plantilla de metadata de columnas (sin type/length/null,
// que salen del esquema de BigQuery, y sin transformation_logic, oculto para FOH)
var COLUMN_EXPORT_FIELDS = ['data_element_name', 'business_definition', 'sensitive', 'valid_values', 'primary_key', 'encrypted', 'column_load_logic'];

// Valor plano de un campo de tag (stringValue / boolValue como Y-N / enum)
function fieldValue(field) {
  if (!field) return '';
  if (field.boolValue !== undefined && field.boolValue !== null) {
    return field.boolValue === true || field.boolValue === 'true' ? 'Y' : 'N';
  }
  if (field.enumValue && field.enumValue.displayName) {
    return field.enumValue.displayName;
  }
  if (field.stringValue !== undefined && field.stringValue !== null) {
    return field.stringValue;
  }
  return '';
}

// Celda CSV con separador ';' (comilla solo cuando hace falta, estándar CSV)
function csvCell(value) {
  var s = String(value === undefined || value === null ? '' : value);
  if (/[;"\r\n]/.test(s)) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}
function downloadCsv(filename, rows) {
  var bom = '﻿';
  var content = rows.map(function (row) {
    return row.map(csvCell).join(';');
  }).join('\n');
  var blob = new Blob([bom + content], {
    type: 'text/csv;charset=utf-8;'
  });
  var url = URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// Plantilla "Metadata de tablas" (campo-valor) con los valores actuales del tag
export function downloadTableMetadataTemplate(tableReference, defaultFields) {
  var rows = [['proyecto', 'dataset', 'tabla', 'campo_metadata', 'valor_a_asignar']];
  TABLE_EXPORT_FIELDS.forEach(function (name) {
    if (defaultFields && defaultFields[name]) {
      rows.push([tableReference.projectId, tableReference.datasetId, tableReference.tableId, name, fieldValue(defaultFields[name])]);
    }
  });
  downloadCsv("metadata_tablas_".concat(tableReference.tableId, ".csv"), rows);
}

// Plantilla "Metadata de columnas" con los valores actuales de cada columna
export function downloadColumnMetadataTemplate(tableReference, columnFields) {
  var rows = [['proyecto', 'dataset', 'Table', 'Column'].concat(COLUMN_EXPORT_FIELDS)];
  (columnFields || []).forEach(function (tag) {
    if (!tag || !tag.column) return;
    rows.push([tableReference.projectId, tableReference.datasetId, tableReference.tableId, tag.column].concat(_toConsumableArray(COLUMN_EXPORT_FIELDS.map(function (name) {
      return fieldValue(tag.fields && tag.fields[name]);
    }))));
  });
  downloadCsv("metadata_columnas_".concat(tableReference.tableId, ".csv"), rows);
}